<template>
  <v-dialog width="700" v-model="internal">
    <v-card
      height="300"
      class="loading-indicator flex-column rounded-md flex-gap-2 d-flex justify-center align-center flex-grow-1"
    >
      <v-progress-circular indeterminate color="primary" :size="100" :width="7">
      </v-progress-circular>
      <div>
        <span class="ml-3 text-h4">{{ $t("analytics.fetchingData") }}</span>
      </div>
      <div>
        <span class="ml-3 text-caption">{{ $t("analytics.pleaseWait") }}</span>
      </div>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["value"],
  computed: {
    internal: {
      get() {
        return this.value;
      },
      set(v) {
        this.$emit("input", v);
      },
    },
  },
};
</script>
